export default {
    titulo: "Failures",
    nueva: "New failure",
    reparada: "Failure repaired",
    pregReparada: "Do you confirm the failure has been repaired?",
    msgDuplicada: "Duplicate failure",
    ok: "Good",
    mal: "Bad",
    obs: "Observations (click to edit)",
    eliminar: "Delete failure",
    pregEliminar: "Are you sure you want to delete the failure?",
    editar: "Edit failure"
}

